var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master-consumable-item-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-9fdc23d0!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master-consumable-item-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MasterConsumableItemEdit.vue
// module id = 648
// module chunks = 1